// rms-message.service.ts
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class RmsMessageService {
  constructor(private snackBar: MatSnackBar) {}

  show(message: string, action: string = 'OK', duration: number = 3000, panelClass: string = ''): void {
    this.snackBar.open(message, action, {
      duration,
      verticalPosition: 'top',
      panelClass: panelClass ? [panelClass] : undefined
    });
  }

  success(message: string): void {
    this.show(message, 'OK', 3000, 'snack-success');
  }

  error(message: string): void {
    this.show(message, 'Dismiss', 5000, 'snack-error');
  }

  info(message: string): void {
    this.show(message, 'OK', 3000, 'snack-info');
  }

  warn(message: string): void {
    this.show(message, 'OK', 4000, 'snack-warn');
  }
}
